<template>
  <div class="messages-list">
    <message-preview
      v-for="message in messages"
      :message="message"
      :key="message.uuid"
      :is-active="message.uuid === activeMessageId"
      @set-active="$emit('set-active', $event)"
      @update="$emit('update')"
    />
    <messages-empty v-if="messages.length === 0" />
    <slot />
  </div>
</template>

<script>
import MessagePreview from './message-preview.vue'
import MessagesEmpty from './messages-empty.vue'

export default {
  components: { MessagePreview, MessagesEmpty },
  name: 'messages-list',
  props: {
    activeMessageId: Number
  },
  computed: {
    messages() {
      return this.$store.getters.messages
    }
  }
}
</script>

<style lang="scss">
.messages-list {
  position: relative;
  min-height: calc(100vh - 400px);
}
</style>
